<template>
    <div class="footprint">

        <!-- timebar start -->
        <div class="footprint-timeopt">
            <p class="footprint-yesterday" @click="Toyesterday">前一天</p>
            <div class="date-box">
                <p class="pitch-date" @click="show=true">{{pitchTime}}</p>
                <i class="triangle"></i>
            </div>
            <p class="footprint-tomorrow" @click="Totomorrow">后一天</p>
        </div>
        <!-- timebar end -->

        <!-- map start -->
        <div class="map" id="map"></div>
        <!-- map end -->

        <!-- play card start -->
        <div class="footprint-detail">
            <div class="detail-head">
                <img class="detail-img" :src="playIconClass" background-size="cover" @click="playSwitch" />
                <div class="slider-container">
                    <van-slider v-model="playConfig.sliderValue" @change="sliderChange" @drag-start="sliderDragStart" @drag-end="sliderDragEnd" />
                </div>
                <span class="speed-state"  @click="playSpeedSwitch">{{speedText}}</span>
            </div>
            <div class="no-data" v-if="playbackRecordData.length<=0">
                无轨迹数据
            </div>
            <div v-else class="detail-cotent">
                <div class="information-type flex">
                    <img class="information-img" :src="imgStatus[locType]" />
                    <p class="card-icon">{{textStatus[locType]}}</p>
                    <p><span style="color: #999999;margin-left:20px;">{{createDate}}</span></p>
                </div>
                <div class="information-address flex">
                    <img class="information-img" src="@/assets/images/pieces.png" background-size="cover" />
                    <p>{{addr}}</p>
                </div>
            </div>
        </div>
        <!-- play card end -->

        <!-- datepicker popup start -->
        <van-calendar v-model="show" :show-confirm="false" @close="onClose" :min-date="minDate" :default-date="defaultDate" :max-date="maxDate" @confirm="onConfirm"  color="#01ADA9" />
        <!-- datepicker popup end -->
        <van-dialog v-model="todaytip" title="操作提示" @confirm="getPlaybackRecord" show-cancel-button>
            <div style="text-align: center;margin:20px 0;">
                <span>是否查询当天足迹信息？</span>
            </div>
        </van-dialog>

    </div>
</template>

<script>
import { isEmpty } from '@/utils/lib/common';
import shortcutTime from '@/utils/lib/shortcut-time';


export default {
    name: 'footprint',
    data() {
        return {
            /* 地图参数配置 */
            mapConfig: {
                map: null, //地图
                points: [], //坐标点
                startMarker: null, //起点标记
                endMarker: null, //终点标记
                userMarker: null, //用户标记
                polyline: null //线段覆盖物
            },
            /* 播放器参数配置 */
            playConfig: {
                state: false, //播放状态
                pause: false, //是否处于暂停状态
                sliderValue: 0, //滑块值
                speed: 500, //播放速度
                timer: null, //定时器
                index: 0 //坐标点下标
            },
            timer: null,
            markers: [],
            pitchTime:this.formatDate(new Date()),//选中的时间
            show:false,//显示日历
            todaytip:true,//显示提示
            minDate: new Date(2021, 8, 1),//可选择最小日期
            maxDate: new Date(),//可选择最大日期
            defaultDate:new Date(),//默认选择日期
            imgStatus:{ //定位类型
                '2':require('@/assets/images/lbs.png'),
                '0':require('@/assets/images/gps.png'),
                '1':require('@/assets/images/wifi.png'),
                // '2':'@/assets/images/jizhan_dingwei.png',
                // '0':'@/assets/images/gps_dingwei.png',
                // '1':'@/assets/images/dingwei.png'
            },
            textStatus:{ //定位类型
                '2':'基站定位',
                '0':'卫星定位',
                '1':'WIFI定位'
            },
            locType:'',//定位类型0 GPS 1 WIFI 2 LBS
            createDate:'',//定位时间
            addr:'无',//定位地址
            num:2,//sudu 
            manOrwoman:false,//头像男女
            playing:true,//播放状态控制显示隐藏
            endPlay:false,//播放完成
            playState:false,
            trackAni:null,
            pathIndex:0,
            markerMy:null,
            locationPathArr:[],
            playbackRecordData: [], //轨迹接口数据
            notPlay:false,//是否有数据播放
        }
    },
    mounted() {
        this.initMap();
        // this.$dialog.confirm({
        //     title: '操作提示',
        //     message: '是否查询当天足迹信息？'
        // }).then(() => {
        //     this.getPlaybackRecord()
        // });
    },
    computed: {
        /**
         * 根据状态显示播放状态
         */
        playIconClass() {
            return this.playConfig.state ? require('@/assets/images/zanting.png') : require('@/assets/images/bofang.png');
        },
        /**
         * 根据速度数值输出中文
         * @returns {String} 返回速度对应的中文
         */
        speedText() {
            let str = '慢';
            let speed = this.playConfig.speed;
            if (speed <= 100) {
                str = '快';
            } else if (speed > 100 && speed <= 500) {
                str = '中';
            }
            return str;
        },
        /**
         * 坐标点更新时给watch提供中间层
         * @returns {Array} 坐标点
         */
        points() {
            return this.mapConfig.points;
        },
        /**
         * 播放配置中的下标数值发生变化时给watch提供中间层
         * @returns {Number} 下标
         */
        index() {
            return this.playConfig.index;
        }

    },
    methods: {
        /**
         * 初始化地图
         */
        initMap() {
            const that = this,
                point = this.mapConfig.points = [new BMap.Point(116.404, 39.915)],
                map = this.mapConfig.map = new BMap.Map('map');

            map.centerAndZoom(point, 1);
            map.enableScrollWheelZoom();
            map.enableScrollWheelZoom(true) // 开启鼠标滚轮缩放
        },
        /**
        * 获取足迹信息
        */
        getPlaybackRecord(){
            this.mapConfig.map.clearOverlays()//更换时间时清除标注
            const that = this;
            let data = {
                ver:1,
                method:'getPlaybackRecord',
                startTime:this.pitchTime+' 00:00:00',
                endTime:this.pitchTime+' 23:59:59'
            }
            this.$http.get(this.$api.userInfo.POST_APPLET,data).then(res => {
                if (res.code === 0) {
                    // this.mapConfig.points = res.data.list
                    // this.points = res.data.list
                    // this.manOrwoman = res.data.sex==="男"

                    if (!isEmpty(res.data.list)) {
                        that.notPlay = true;
                        that.playbackRecordData = res.data.list;
                        that.updatePoints();
                    } else {
                        that.$toast('轨迹数据为空');
                    }
                } else {
                    this.$toast({
                        message: res.msg,
                        duration: 2000,
                        icon: 'close'
                    });
                }
            })
        },
        /**
        * 获取前一天足迹信息
        */
        Toyesterday(){
            let newDataStr = this.pitchTime.replace(/\.|\-/g, '/')
            if(new Date(newDataStr).getTime()-24*60*60*1000<this.minDate)return//小于最长可查询日期便禁止
            this.pitchTime = this.formatDate(new Date(newDataStr).getTime()-24*60*60*1000);//日期显示
            this.defaultDate = new Date(this.pitchTime)//日历显示
            this.getPlaybackRecord()
        },
        /**
        * 获取后一天足迹信息
        */
        Totomorrow(){
            let newDataStr = this.pitchTime.replace(/\.|\-/g, '/')
            if(new Date(newDataStr).getTime()+24*60*60*1000>new Date().getTime()){
                this.$toast('已无最新数据')
                return
            }
            this.pitchTime = this.formatDate(new Date(newDataStr).getTime()+24*60*60*1000);
            this.defaultDate = new Date(this.pitchTime)
            this.getPlaybackRecord()
        },
        /**
         * 创建标记
         * @param {Object} options 配置文件
         * @param {Object} options.latLng  坐标
         * @param {Object} options.icon  图标
         * @param {Stirng} options.icon.url 图标地址
         * @param {Object} options.icon.size 图标大小
         * @param {Object} options.icon.imageSize 图标背景大小
         * @param {Object} options.icon.anchor 图标背景偏移量
         */
        createMarker(options) {

            /* 默认配置 */
            const defaults = {
                latLng: {
                    lng: 116.404,
                    lat: 39.915
                },
                icon: {
                    url: '',
                    size: {

                        width: 24,
                        height: 24
                    },
                    imageSize: {
                        width: 24,
                        height: 24
                    },
                    anchor: {
                        x: 12,
                        y: 12
                    }
                }
            };
            const settings = _.merge({}, defaults, options); //合并配置

            /* 创建图标 */
            const icon = new BMap.Icon(
                settings.icon.url,
                new BMap.Size(settings.icon.size.width, settings.icon.size.height),
                {
                    anchor: new BMap.Size(settings.icon.anchor.x, settings.icon.anchor.y),
                    imageSize: new BMap.Size(settings.icon.imageSize.width, settings.icon.imageSize.width)
                }
            );

            /* 创建坐标点 */
            const point = new BMap.Point(settings.latLng.lng, settings.latLng.lat);

            /* 创建标记 */
            const marker = new BMap.Marker(point, {
                icon: icon
            });
            return marker;
        },
        /**
         * 更新marker标记
         */
        updateMarker() {
            if(!this.notPlay)return
            let { startMarker, endMarker, userMarker, points } = this.mapConfig;
            const len = points.length - 1;
            // if (startMarker && endMarker && userMarker) { //因为清除了所有覆盖物，所以不能改变位置
            //     this.mapConfig.startMarker.setPosition(points[0]);
            //     this.mapConfig.endMarker.setPosition(points[len]);
            //     this.mapConfig.userMarker.setPosition(points[0]);
            //     return;
            // }
            /* 创建起点标记 */
            this.mapConfig.startMarker = this.createMarker({
                latLng: points[0],
                icon: {
                    url: require('@/assets/images/starting_point.png')
                }
            });

            /* 创建终点标记 */
            this.mapConfig.endMarker = this.createMarker({
                latLng: points[len],
                icon: {
                    url: require('@/assets/images/end_point.png')
                }
            });

            /* 创建用户标记 */
            this.mapConfig.userMarker = this.createMarker({
                latLng: points[0],
                icon: {
                    url: require('@/assets/images/location_boy.png'),
                    size: {
                        width: 48,
                        height: 48
                    },
                    imageSize: {
                        width: 48,
                        height: 48
                    },
                    anchor: {
                        x: 24,
                        y: 48
                    }
                }
            });

            /* 标记添加到地图 */
            this.mapConfig.map.addOverlay(this.mapConfig.startMarker);
            this.mapConfig.map.addOverlay(this.mapConfig.endMarker);
            this.mapConfig.map.addOverlay(this.mapConfig.userMarker);

        },
        /**
         * 更新Polyline线段
         * @param {Array} pointArr 标记集合点 
         */
        updatePolyline(pointArr) {
            pointArr = pointArr || [];
            // let polyline = this.mapConfig.polyline;
            // if (polyline) {
            //     let { map, polyline } = this.mapConfig;
            //     polyline.setPath(pointArr);
            //     map.removeOverlay(polyline);
            //     map.addOverlay(polyline);
            //     return;
            // }
            // /* 创建折线 */
            // this.mapConfig.polyline = new BMap.Polyline(pointArr, { strokeColor: "blue", strokeWeight: 2, strokeOpacity: 0.5 });

            // /* 标记折线到地图 */
            // this.mapConfig.map.addOverlay(this.mapConfig.polyline);
        },

        /**
         * 更新线段和用户标记
         * @param {Array} pointArr 标记集合点 
         * @param {Number} index 下标 
         */
        updateOverlay(index) {
            let { points, userMarker } = this.mapConfig;
            // this.setBestViewport()
            let pointArr = points.slice(0, index + 1);
            this.updatePolyline(pointArr);
            userMarker.setPosition(pointArr[index]);
            /* 创建用户标记 */
            let Marker = this.createMarker({
                latLng: pointArr[index],
                icon: {
                    url: require('@/assets/images/location_boy.png'),
                    size: {
                        width: 48,
                        height: 48
                    },
                    imageSize: {
                        width: 48,
                        height: 48
                    },
                    anchor: {
                        x: 24,
                        y: 48
                    }
                }
            });
            this.mapConfig.map.addOverlay(Marker);
        },

        /**
         * 更新坐标点数据
         */
        updatePoints() {
            this.mapConfig.points = this.playbackRecordData.map(item => {
                return new BMap.Point(item.longitude, item.latitude);
            });
        },
        /**
         * 设置地图最佳视角
         */
        setBestViewport() {
            let points = this.mapConfig.points;
            const view = this.mapConfig.map.getViewport(points); //获取最佳视角
            const zoom = view.zoom - 1; //获取最佳视角的缩放层级，减1更好适配边界问题
            const centerPoint = view.center; //获取最佳视角的中心点
            this.mapConfig.map.centerAndZoom(centerPoint, zoom); //设置中心点和缩放层级
        },

        /**
         * 更新位置信息
         */
        updateLocationInfo(index) {
            if(!this.playbackRecordData || this.playbackRecordData.length<=0) return
            index = index ? parseInt(index) : 0
            let info = this.playbackRecordData[index || 0];
            this.addr = info.addr
            this.createDate = info.gpsTime
            this.locType = info.locType
        },
        /**
         * 播放切换
         */
        playSwitch() {
            if(!this.notPlay){
                this.$toast('轨迹数据为空');
                return
            }
            this.playConfig.state = !this.playConfig.state; //点击播放按钮切换播放状态
            if (this.playConfig.state) { //如果状态为true进入播放模式
                if (this.playConfig.index + 1 >= this.mapConfig.points.length) {
                    this.playReset();//播放重置
                }
                this.playStart();
            } else {
                this.playStop();
            }
        },

        /**
         * 播放定时器打开
         */
        playTimerOpen() {
            this.playConfig.timer = window.setInterval(() => {
                this.playConfig.index++;
            }, this.playConfig.speed);
        },
        /**
         * 播放定时器关闭
         */
        playTimerClose() {
            window.clearInterval(this.playConfig.timer);
        },
        /**
         * 播放开始
         */
        playStart() {
            this.setBestViewport(); //设置最佳视角
            this.playConfig.state = true;

            this.playConfig.index++;
            this.playTimerOpen(); //开启定时器
        },
        /**
         * 播放暂停
         */
        playPause() {
            this.playTimerClose();
            this.playConfig.pause = true;
        },
        /**
         * 播放停止
         */
        playStop() {
            this.playTimerClose();
            this.playConfig.state = false;
            this.playConfig.pause = false;
            let index = this.playConfig.index;
            let len = this.mapConfig.points.length;
            if (index >= len) {
                this.$toast('播放完成');
            }

        },
        /**
         * 播放重置
         */
        playReset() {
            this.mapConfig.map.clearOverlays()//清除标注
            this.updateMarker()
            this.playConfig.state = false;
            this.playConfig.pause = false;
            this.playConfig.index = 0;
            this.playConfig.sliderValue = 0;
            // this.playConfig.speed = 1000;
            this.playTimerClose();
            this.playConfig.timer = null;
            this.setBestViewport(); //设置最佳视角
        },
        /**
         * 播放速度切换
         */
        playSpeedSwitch() {
            let speed = this.playConfig.speed;
            this.playConfig.speed = speed == 1000 ? 500 : speed == 500 ? 100 : 1000;
            if (this.playConfig.state) {
                this.playTimerClose(); //关闭定时器
                this.playTimerOpen(); //重新打开定时器
            }

        },
        /* 滑块值改变响应 */
        sliderChange(val) {
            let len = this.mapConfig.points.length - 1;

            this.playConfig.index = Math.round(val / 100 * len); //此处的值可能会有小数点，但是下标是不能有小数点，用四舍五入处理
            this.mapConfig.map.clearOverlays()//更换时间时清除标注
            this.updateMarker();
            for (let i = 0; i < this.playConfig.index; i++) {
                this.updateOverlay(i)
            }
        },
        /**
         * 滑块拖拽开始
         */
        sliderDragStart() {
            if (this.playConfig.state) {
                this.playPause();
            }

        },
        /**
         * 滑块拖拽结束
         */
        sliderDragEnd() {
            if (this.playConfig.pause) {
                this.playStart();
            }
        },
        /**
         * 更新Slider值
         */
        updateSlider() {

            let len = this.mapConfig.points.length - 1,
                index = this.playConfig.index;
            this.playConfig.sliderValue = Math.round(index / len * 100);
        },
        /**
        * 关闭日历
        */
        onClose(){
            this.show = false
        },
        /**
        * 日期格式处理
        */
        formatDate(date) {
            date = new Date(date);
            return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
        },
        /**
        * 选择日期
        */
        onConfirm(event) {
            this.show = false
            this.pitchTime = this.formatDate(event);//日期显示
            this.getPlaybackRecord()
        },
    },
    watch: {
        /* 坐标点数组更新响应 */
        points: {
            handler: function (val, oldval) {
                this.updateMarker();
                this.updatePolyline();
                this.setBestViewport(); //设置最佳视角
                this.playReset(); //重置播放设置
                this.updateLocationInfo();
            },
            deep: true//深度监听
        },
        /* 下标值更新响应 */
        index(val) {
            let len = this.mapConfig.points.length;
            if (val >= len) {
                return this.playStop();
            }
            this.updateOverlay(val);
            this.updateSlider();
            this.updateLocationInfo(val);
        },
        /* 下标值更新响应 */
    },
    beforeDestroy() {
        this.playTimerClose(); //离开组件清除定时器
    }
}
</script>

<style lang="scss" scoped>
.footprint{
  height: 100vh;
  display: flex;
  flex-direction: column;
  .map{
      flex: 1;
      padding-bottom: 94px;
  }
}
.flex{
  display: flex;
  align-items: center;
}
.footprint-timeopt{
  font-size: 28px;
  height: 78px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #e5e5e5;
}
.footprint-timeopt .footprint-yesterday{
  margin-left: 80px;
}
.footprint-timeopt .footprint-tomorrow{
  margin-right: 80px;
}
.footprint-timeopt .pitch-date{
  font-weight: 600;
  font-family: ArialMT;
  color: #111111;
}
.date-box{
  display: flex;
  align-items: center;
}
.footprint-timeopt .triangle{
  width: 0;
  margin: 15px 0 0 10px;
  border-top: 10px solid #c2c2c2;
  border-bottom: 10px solid transparent;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
}
.no-data{
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  color: #999;
  font-size: 36px;
}
.footprint-detail{
  position: relative;
  width: 100%;
  height: 260px;
  bottom: 100px;
  background: #fff;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  /* overflow: auto; */
  display: flex;
  flex-direction: column;
}
.detail-head{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  width: 100%;
  border-radius: 50%;
  background: #fff;
}
.speed-state{
    font-size: 30px;
    margin: 0 30px 0 10px;
}
.detail-head .detail-img{
  width: 54px;
  height: 54px;
  margin: 0 10px 0 50px;
  /* margin: 0 55px; */
}
.detail-head .slider-container{
    flex: 1;
    padding: 0 10px;
    .van-slider {
        // margin-top: 12px;
    }
    .van-slider__button {
        $size: 6px;
        width: $size;
        height: $size;
        background-color: #01ADA9;
    }
}
.detail-cotent{
  color: #666666;
  font-size: 28px;
  margin-top: 30px;
  flex: 1;
}
.information-type{
 margin-bottom: 10px;
}
.information-type .information-img{
  margin: 0 30px 0 50px;
  width: 36px;
  height: 36px;
}
.information-address{
    >p{
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
    }
    padding-right: 20px;
}
.information-address .information-img{
  margin: 0 30px 0 50px;
  width: 36px;
  height: 36px;
}
.information-address>p{
  flex: 1;
  display: flex;
  flex-wrap: wrap;
}
</style>
<style lang="scss">
$blueColor: #01ADA9;
.footprint {
    .van-overlay{
        height: calc(100% - 100px);;
    }
}
.footprint {
    .slider-container {
        .van-slider__button-wrapper {
            .van-slider__button {
                width: 20px;
                height: 20px;
                background-color: #01ADA9;
            }
            &::after {
                top: 50%;
                left: 50%;
                width: 40px;
                height: 40px;
                transform: translate(-50%, -50%);
            }
        }
    }
}
/* 控制弹框透明层不覆盖底部导航栏 */
.footprint-dialog-overlay-ctrl {
    .van-dialog {
        margin-top: -25px; //导航条的高度为50px，减去导航条的一半使弹框居中
    }
    .van-overlay {
        height: calc(100% - 50px); //弹框覆盖层减去导航的高度，使导航栏不被遮盖
        background-color: rgba(0, 0, 0, 0.3);
    }
}
</style>
